import { render, staticRenderFns } from "./PDFDocument.vue?vue&type=template&id=5fabd068"
import script from "./PDFDocument.vue?vue&type=script&lang=ts"
export * from "./PDFDocument.vue?vue&type=script&lang=ts"
import style0 from "./PDFDocument.vue?vue&type=style&index=0&id=5fabd068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports